import { render, staticRenderFns } from "./inlinePops.vue?vue&type=template&id=48c3fcd6"
import script from "./inlinePops.vue?vue&type=script&lang=js"
export * from "./inlinePops.vue?vue&type=script&lang=js"
import style0 from "./inlinePops.vue?vue&type=style&index=0&id=48c3fcd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports